import React from "react";

export const secondaryClasses =
    "inline-flex justify-center py-2 px-4 border border-2 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-800 bg-white " +
    "hover:bg-gray-200 hover:text-black " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 " +
    "disabled:bg-gray-100 disabled:text-gray-400";

export const secondaryCompactClasses =
    "inline-flex justify-center py-1 px-2 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-800 bg-white " +
    "hover:bg-gray-200 hover:text-black " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 " +
    "disabled:bg-gray-100 disabled:text-gray-400";

export const secondaryCompactSelectedClasses =
    "inline-flex justify-center py-1 px-2 border border-brand-600 shadow-sm text-xs font-medium rounded text-white bg-brand-600 " +
    "hover:bg-brand-700 " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500";

const SecondaryButton = React.forwardRef<
    HTMLButtonElement,
    React.ButtonHTMLAttributes<HTMLButtonElement>
>((props, ref) => {
    const { className, ...rest } = props;
    const extendedClassName = `${className ?? ""} ${secondaryClasses}`;
    return <button ref={ref} className={extendedClassName} {...rest} />;
});

SecondaryButton.displayName = "SecondaryButton";
export { SecondaryButton };

interface SecondaryCompactButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    selected?: boolean;
}

const SecondaryCompactButton = React.forwardRef<
    HTMLButtonElement,
    SecondaryCompactButtonProps
>((props, ref) => {
    const { className, selected, ...rest } = props;
    const baseClasses = selected
        ? secondaryCompactSelectedClasses
        : secondaryCompactClasses;
    const extendedClassName = `${className ?? ""} ${baseClasses}`;
    return <button ref={ref} className={extendedClassName} {...rest} />;
});

SecondaryCompactButton.displayName = "SecondaryCompactButton";
export { SecondaryCompactButton };
